let category = {
    name: ''
};

export default category;